<template>
  <div class="account-row account-details">
    <div class="heading">
      <!-- <h2>Account Det<span ref="jojo">a</span>ils</h2> -->
    </div>
    <!-- <p>{{$ml.get(`Here must be information about plan,crops etc.`)}}</p> -->

    <p>{{counters}}</p>
    <!-- <audio controls style="display:none;" id="jojo">
      <source src="@/assets/audio/jojo.mp3" type="audio/ogg; codecs=vorbis">
      <source src="@/assets/audio/jojo.mp3" type="audio/mpeg">
    </audio> -->
    <div
      class="ref"
      v-if="(this.$store.getters['user/data'].globalRole == 'company'
        || this.$store.getters['user/data'].subsPlan == 'elite'
        || this.$store.getters['user/data'].subsPlan == 'premium')
        && this.$store.getters['user/data'].connectsTo == 0"
    >
      <div class="heading">
        <h2>{{$ml.get(`Referral link`)}}</h2>
      </div>

        <input type="text" onClick="this.select()" v-model="refLink" readonly>
    </div>
  </div>
</template>

<script>
import API from '@/api'

export default {
  data() {
    return {
      counter : 0,
      refLink : null,
      counters : null,
    }
  },
  methods: {
    getRefferalLink() {
      return API.user.getReferralLink().then(res => {
        this.refLink = 'http://'+location.host+'/#/auth/select-role?ref='+res.data.data;
      });
    },
    getUserCounters() {
      return API.user.getUserCounters().then(res => {
        this.counters = res.data.data;
      })
    }
  },
  // computed : {
  //   refLink() {
  //     return
  //   }
  // },
  created() {
    this.getRefferalLink();
    // this.getUserCounters();
  },
  mounted() {
    // this.$refs.jojo.onclick = ()=> {
    //   this.counter++;
    //   if(this.counter == 5) {
    //     var x = document.getElementById("jojo");
    //     x.play();
    //   }
    //
    // }
  }
}
</script>
 {
<style lang="scss" scoped>
.ref {
  input {
    width: 100%;
    padding: 8px 12px 8px 12px;
    background-color: #fff;
    border: 1px solid $mainBlue;
    border-radius: 3px;
    outline: none;
    color: $mainBlue;
    font-size: 16px;
    height: 42px;
  }
}
</style>
